import React, { useState } from 'react'

const BookingAddons = ({lang,t,addons,selectedAddons,setSelectedAddons}) => {
 
  return (
    <>
      {addons && addons.length > 0 && (
        <div className="col-12 mt-2">
          <label className="form-label fw-bold">{t("selectAddons")}</label>

          <div className="row g-2">
            {addons.map((item) => {
              const isSelected = selectedAddons?.some(
                (x) => x.addonId === item.addonId,
              );

              const quantity =
                selectedAddons?.find((x) => x.addonId === item.addonId)?.quantity ||
                1;

              return (
                <div key={item.addonId} className="col-12">
                  <div className="card shadow-sm">
                    <div className="card-body d-flex align-items-center justify-content-between">
                      {/* LEFT SIDE */}
                      <div className="d-flex align-items-center gap-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={isSelected}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedAddons((prev) => [
                                ...prev,
                                { addonId: item.addonId, quantity: 1 },
                              ]);
                            } else {
                              setSelectedAddons((prev) =>
                                prev.filter((x) => x.addonId !== item.addonId),
                              );
                            }
                          }}
                        />

                        <div>
                          <div className="fw-bold">{item.name[lang]}</div>
                          <small className="text-muted">
                            {item.price} {t("riyal")}
                          </small>
                        </div>
                      </div>

                      {/* RIGHT SIDE (Quantity) */}
                      {isSelected && (
                        <div className="d-flex align-items-center gap-2">
                          <button type='button'
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              setSelectedAddons((prev) =>
                                prev.map((x) =>
                                  x.addonId === item.addonId
                                    ? {
                                        ...x,
                                        quantity: Math.max(1, x.quantity - 1),
                                      }
                                    : x,
                                ),
                              );
                            }}
                          >
                            -
                          </button>

                          <span className="px-2">{quantity}</span>

                          <button type='button'
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              setSelectedAddons((prev) =>
                                prev.map((x) =>
                                  x.addonId === item.addonId
                                    ? { ...x, quantity: x.quantity + 1 }
                                    : x,
                                ),
                              );
                            }}
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default BookingAddons